// components/MailtoButton/MailtoButton.jsx
import React from 'react';
import './MailtoButton.css';

const MailtoButton = ({ 
  to, 
  subject = '', 
  body = '', 
  children = 'Envoyer un email',
  className = '',
  icon = null
}) => {
  // Encoder les paramètres pour l'URL mailto
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  
  const mailtoUrl = `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;

  return (
    <a 
      href={mailtoUrl}
      className={`mailto-button ${className}`}
      aria-label={`Envoyer un email à ${to}`}
    >
      {icon && <span className="mailto-button-icon">{icon}</span>}
      <span className="mailto-button-text">{children}</span>
    </a>
  );
};

export default MailtoButton;